<template>
  <div class="sgl-footer--wrapper">
    <div class="container">
      <div class="sgl-footer">
        <div class="sgl-footer--logo">
          <svg class="kuzbass_logo" width="140" height="37" viewBox="0 0 140 37" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.69922 28.92V4.99999H14.9992C17.59 4.85885 20.1473 5.63809 22.2192 7.19999C23.1157 7.95844 23.8255 8.91309 24.2937 9.98998C24.762 11.0669 24.976 12.2371 24.9192 13.41C24.9653 15.091 24.494 16.7455 23.5692 18.15C22.6745 19.4671 21.4071 20.4873 19.9292 21.08C18.2436 21.7641 16.4382 22.1041 14.6192 22.08H11.3392V28.96L4.69922 28.92ZM11.3392 16.92H14.4892C15.4965 16.9586 16.4838 16.6318 17.2692 16C17.5985 15.706 17.8589 15.3429 18.0318 14.9367C18.2046 14.5305 18.2857 14.0911 18.2692 13.65C18.2946 13.2048 18.2176 12.7598 18.0443 12.3489C17.8709 11.9381 17.6058 11.5725 17.2692 11.28C16.4561 10.6887 15.4627 10.3988 14.4592 10.46H11.3392V16.92ZM28.6592 28.92V4.99999H35.2992V23.1H43.4792V4.99999H50.1192V23.1H52.8192L52.0592 33.71H46.4492V28.92H28.6592ZM55.1992 17C55.2015 15.3195 55.5416 13.6565 56.1992 12.11C56.789 10.6183 57.678 9.26321 58.8113 8.12812C59.9447 6.99304 61.2984 6.10204 62.7892 5.50999C64.3748 4.85387 66.0733 4.51416 67.7892 4.50999C69.7402 4.44719 71.6761 4.87143 73.422 5.74439C75.1679 6.61735 76.6689 7.91152 77.7892 9.50999L72.9992 13.28C72.3999 12.43 71.6085 11.7335 70.6893 11.2469C69.7701 10.7604 68.7491 10.4976 67.7092 10.48C66.9302 10.4637 66.1575 10.6224 65.4479 10.9443C64.7384 11.2662 64.11 11.7431 63.6092 12.34C62.5119 13.6392 61.9379 15.3005 61.9992 17C61.9481 18.6797 62.5218 20.3187 63.6092 21.6C64.11 22.1969 64.7384 22.6738 65.4479 22.9957C66.1575 23.3176 66.9302 23.4763 67.7092 23.46C68.7587 23.4985 69.798 23.2421 70.7092 22.72C71.6448 22.1386 72.4679 21.3933 73.1392 20.52L78.1392 24.1C77.4022 25.1307 76.535 26.0617 75.5592 26.87C74.5369 27.6831 73.3792 28.3094 72.1392 28.72C70.6586 29.2222 69.1025 29.4658 67.5392 29.44C65.3682 29.4683 63.2286 28.9196 61.3392 27.85C59.4791 26.8019 57.9431 25.2625 56.8992 23.4C55.7725 21.4562 55.1856 19.2467 55.1992 17V17ZM81.1292 17C81.1171 15.324 81.4365 13.6621 82.0692 12.11C82.6672 10.6216 83.5603 9.26953 84.6945 8.13528C85.8288 7.00103 87.1808 6.10802 88.6692 5.50999C90.2549 4.85436 91.9533 4.51468 93.6692 4.50999C95.6199 4.44899 97.5552 4.87402 99.3008 5.74683C101.046 6.61964 102.548 7.91283 103.669 9.50999L98.8092 13.29C98.2109 12.4414 97.4211 11.7456 96.5037 11.2592C95.5864 10.7727 94.5674 10.5092 93.5292 10.49C92.7499 10.4715 91.9765 10.6292 91.2666 10.9513C90.5567 11.2733 89.9286 11.7514 89.4292 12.35C88.3588 13.6558 87.8133 15.3137 87.8992 17C87.8433 18.6805 88.4176 20.3212 89.5092 21.6C90.0086 22.1985 90.6367 22.6767 91.3466 22.9987C92.0565 23.3208 92.8299 23.4784 93.6092 23.46C94.6588 23.499 95.6982 23.2426 96.6092 22.72C97.5347 22.1198 98.3444 21.3576 98.9992 20.47L103.999 24.05C103.254 25.0737 102.387 26.0037 101.419 26.82C100.396 27.632 99.2387 28.2582 97.9992 28.67C96.5186 29.1722 94.9625 29.4158 93.3992 29.39C91.2311 29.4209 89.0941 28.872 87.2092 27.8C85.3414 26.7553 83.7981 25.2154 82.7492 23.35C81.663 21.4115 81.1044 19.2219 81.1292 17V17Z"
                fill="#FCFCFC"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M124.899 29.0704L116.749 20.9104V29.0704H109.279V3.36035L118.149 12.0904L123.289 4.97035L132.279 4.98035L123.419 17.2704H123.409L135.389 29.0704H124.899Z"
                  fill="#FCFCFC"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M116.75 10.71L135.39 29.07H124.9L116.75 20.91V10.71Z"
                  fill="#74CDA9"/>
          </svg>
        </div>
        <nav class="sgl-footer--nav">
          <div class="footer-dropdown" @mouseover="toggleList" @mouseout="toggleList">
            <div :class="[{active:tournamentsListVisible}, 'button']"
                 @click.self="$router.push({ name: 'allTournaments'})">
              Все турниры
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 6.5L8 10.5L4 6.5" stroke="#EAEAEA" stroke-linejoin="round"/>
              </svg>
            </div>
            <div ref="listContainer" class="list-container">
              <div class="list-wrapper" v-if="dataReady">
                <router-link :to="{name: 'sgl-events', params: {id: game.id}}" class="discipline-logo"
                             v-for="game in this.GET_TOURNAMENT_GROUPS" :key="game.id"
                             active-class=""
                             exact-active-class="active">
                  <img :src="GET_SPONSOR_GAMES.find(el => String(el.id) === String(game.gameInfo.id)).logo" alt="#">
                </router-link>
              </div>
            </div>
          </div>
          <ul>
            <li>
              <router-link to="/videos">Видео</router-link>
            </li>
            <li>
              <router-link to="/FAQ">FAQ</router-link>
            </li>
          </ul>
        </nav>

        <footer-component-socials :social-links="footerInfo.links"/>

        <div class="sgl-footer--bot-group">

          <a v-if="this.footerInfo.file_user_agreement"
             :href="this.footerInfo.file_user_agreement">
            Пользовательское соглашение
          </a>

          <a v-if="this.footerInfo.file_privacy_policy"
             :href="this.footerInfo.file_privacy_policy"
             target="_blank">
            Политика конфиденциальности
          </a>
          <span>SGL eSports holding company® 2021</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import FooterComponentSocials from "@/components/footer/footerComponent-socials";
import { API } from "@/Vuex/axios-config";
import { includeFilteringByType } from "@/otherJS/include-filtering";
import { SPONSOR_ID } from "@/config";

export default {
  name: "footerComponent",
  components: { FooterComponentSocials },
  data() {
    return {
      tournamentsListVisible: false,
      dataReady: false,
      footerInfo: {}
    }
  },
  methods: {
    ...mapActions([
      'GET_SPONSOR_DISCIPLINES',
      'SET_TOURNAMENT_GROUPS'
    ]),
    toggleList() {
      if (window.matchMedia("(min-width: 525px)").matches) {
        if (this.tournamentsListVisible) {
          this.$refs.listContainer.style.maxHeight = `0px`
          this.tournamentsListVisible = false
        } else {
          this.$refs.listContainer.style.maxHeight = `${this.$refs.listContainer.scrollHeight}px`
          this.tournamentsListVisible = true
        }
      }
    },
    async getData() {
      //TODO надо будет убрать отсюда, потому что в App.vue мы их уже получаем. Сделать прелоадер в шапке, пока они грузятся
      await this.GET_SPONSOR_DISCIPLINES()
      await this.SET_TOURNAMENT_GROUPS()
      this.dataReady = true
    },
    async getFooterInfo() {
      const response = await API({
        method: 'get',
        url: `/footer-infos?filter[sponsor_id]=${SPONSOR_ID}&include=socialLinks.logo,filePrivacyPolicy,fileUserAgreement`
      })
      if (response.data.data.length) {
        const footerInfo = {}

        const links = includeFilteringByType(response.data.included, 'social-links')
        const attachments = includeFilteringByType(response.data.included, 'attachments')

        for (let link of links) {
          for (let logo of attachments) {
            link.logo = attachments.find(el => String(el.id) === String(link.relationships.logo.data.id)).attributes.url
          }
        }

        footerInfo.file_privacy_policy = attachments.find(el => String(el.id) === String(response.data.data[0].relationships.filePrivacyPolicy.data.id)).attributes.url
        footerInfo.file_user_agreement = attachments.find(el => String(el.id) === String(response.data.data[0].relationships.fileUserAgreement.data.id)).attributes.url
        footerInfo.links = links

        this.footerInfo = footerInfo
      }
    }
  },
  computed: {
    ...mapGetters([
      'GET_SPONSOR_GAMES',
      'GET_TOURNAMENT_GROUPS'
    ]),
  },
  mounted() {
    this.getData()
    this.getFooterInfo()
  }
}
</script>

<style scoped lang="scss">
</style>
